import { render, staticRenderFns } from "./EditProfileIcon.vue?vue&type=template&id=567aca28&"
import script from "./EditProfileIcon.vue?vue&type=script&lang=js&"
export * from "./EditProfileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports